import { AllOffers, ModelKey, ModelOffers } from "../types/offers";

export const getOffer = (offers: AllOffers, model: ModelKey, year: string, sales_code: string) => {
  if (offers?.[year]?.[model]) {
    const modelOffer = offers[year][model] as ModelOffers;
    const trimOffer = offers[year][model]?.trims.filter(x => x.sales_code === sales_code)[0];
    if (trimOffer) {
      return {
        ...modelOffer,
        trims: [ trimOffer ],
        singleTrim: true
      }
    }
  }
  return undefined;
};
